SELECTABLE_AUTH = ["callcenter", "operator"]
$(document).ready(function() {
  // admin_userページでなければ処理を行わない
  console.log(location.href.match(/admin_user/).length === 0)
  if(location.href.match(/admin_user/).length === 0) { return; }
  
  $("#auth_select").on('change', function(event) {
    console.log($(event.target).val())
    if(SELECTABLE_AUTH.includes($(event.target).val())) {
      $("#sales_offices_select").removeAttr("disabled")
    } else {
      $("#sales_offices_select").val("")
      $("#sales_offices_select").attr("disabled", true);
    }
  })
})
